import { filter} from 'rxjs/operators';
import { NavigationEnd, Router, Route, ActivatedRoute, Navigation } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { SubSink } from 'subsink';
import { BaseService } from '../base.service';
import { Constants } from '@app/core/utilities/constants';

@Injectable({
  providedIn: 'root'
})

export class RoutingStateService extends BaseService {
  public currentNavigation: Navigation;
  public previousNavigation: Navigation;
  private history = [];

  public subs = new SubSink();

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    super();
  }

  public loadRouting() {
    this.subs.sink = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({urlAfterRedirects}: NavigationEnd) => {
        const currentNavigation = this.router.getCurrentNavigation();
        if (currentNavigation) {
          this.previousNavigation = this.currentNavigation;
          this.currentNavigation = currentNavigation;
        }
        this.history = [...this.history, urlAfterRedirects];
      });
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] || '/dashboard';
  }

  /**
   * Determines whether the current route is an HTTP error page.
   *
   * Two paths lead to the error page:
   * 1. Interceptor redirect — API returns 403/404/410, interceptor navigates to /httperror.
   *    URL becomes /httperror but route data has no httpErrorStatus (error is in nav extras).
   * 2. Wildcard ** route — user hits a non-existent URL. URL stays as-is,
   *    but route data has httpErrorStatus: 404.
   */
  public isErrorPage(url: string): boolean {
    if (url === '/' + Constants.HTTP_ERROR_ROUTE) {
      return true;
    }
    const deepest = this.getDeepestRoute();
    return deepest.snapshot.data && deepest.snapshot.data.httpErrorStatus != null;
  }

  /**
   * Returns the deepest (leaf) ActivatedRoute in the route tree.
   * Angular's ActivatedRoute is a tree; this walks firstChild links
   * until it reaches the terminal route.
   */
  public getDeepestRoute(): ActivatedRoute {
    let route = this.route.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
